/**
 * Descrição de recurso (jornada, missão, quiz, prêmio) vem como HTML rico da
 * CMS. Uso: teaser de texto puro em contexto sem `dangerouslySetInnerHTML`
 * (ex.: `PageHero.Subtitle`, que já bound a altura via `clamp` — este helper
 * só garante que a tag não apareça como texto literal).
 */
export const htmlToText = (html?: string | null): string =>
  String(html ?? '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
